import React, { useEffect, useState } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { searchProps } from 'components/searchbar'
import qs from 'query-string'

export default function CategoryTitle({ children, code }) {
  const location = useLocation()
  const [search, setSearch] = useState<searchProps>({})

  useEffect(() => {
    let s: searchProps = qs.parse(location.search)
    setSearch({ ...s, c: code, type: 'app', page: 1 })
  }, [code, location])

  return <Link to={`/search?${qs.stringify(search)}`}>{children}</Link>
}
